import { Button, Header, Modal } from '@mairistem/composants';
import React from 'react';

import { formatMonetaire } from '@/utils';
import RelanceSummaryTile from './RelanceSummaryTile';
import RelanceTile from './RelanceTile';

type ModalRecapRelancesProps = {
  total: number;
  totalReste: number;
  nombreRelances: number;
  nombreMailsPotentiel: number;
  nombreFacturesMails: number;
  mailsSent: number;
  pdfUrl: string | null;
  onClose: () => void;
};

const ModalRecapRelances = (props: ModalRecapRelancesProps) => {
  const {
    total,
    totalReste,
    nombreRelances,
    nombreMailsPotentiel,
    nombreFacturesMails,
    mailsSent,
    pdfUrl,
    onClose,
  } = props;

  const nombreRelancesCourrier = nombreRelances - nombreMailsPotentiel;
  const nombreFacturesCourrier = total - nombreFacturesMails;

  const hasOnlyOneTile =
    (nombreMailsPotentiel > 0 && nombreRelancesCourrier === 0) ||
    (nombreMailsPotentiel === 0 && nombreRelancesCourrier > 0);

  const handleCourrierClick = React.useCallback(() => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  }, [pdfUrl]);

  // Textes au passé composé pour le résumé
  const summaryTitle = `${nombreRelances <= 1 ? '1' : nombreRelances} ${nombreRelances <= 1 ? 'relance a été générée' : 'relances ont été générées'}`;
  const summarySubtitle = `pour un montant de ${formatMonetaire(totalReste, 2, true)}`;

  // Textes au passé composé pour les tuiles
  const mailText = hasOnlyOneTile
    ? 'Les relances ont été envoyées par mail'
    : `${mailsSent} ${mailsSent <= 1 ? 'relance a été envoyée' : 'relances ont été envoyées'} par mail`;

  const courrierText = hasOnlyOneTile
    ? 'Les relances ont été générées pour envoi par courrier'
    : `${nombreRelancesCourrier} ${nombreRelancesCourrier <= 1 ? 'relance a été générée' : 'relances ont été générées'} pour envoi par courrier`;

  return (
    <Modal open size="tiny" onClose={onClose} closeIcon>
      <Modal.Header>Récapitulatif des relances</Modal.Header>
      <Modal.Content>
        <RelanceSummaryTile
          relancesCount={nombreRelances}
          montantTotal={formatMonetaire(totalReste, 2, true)}
          title={summaryTitle}
          subtitle={summarySubtitle}
          fullWidth={!hasOnlyOneTile}
          color="green"
          backgroundColor="rgba(31, 175, 137, 0.05)"
        />

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            columnGap: '1em',
            marginBottom: '2em',
          }}
        >
          {nombreMailsPotentiel > 0 && (
            <RelanceTile
              icon={{ name: 'Send' }}
              label="par mail"
              relancesCount={mailsSent}
              facturesCount={nombreFacturesMails}
              isMail
              showOnlyTile={hasOnlyOneTile}
              text={mailText}
              color="green"
            />
          )}
          {nombreRelancesCourrier > 0 && (
            <RelanceTile
              icon={{ name: 'Mail' }}
              label="par courrier"
              relancesCount={nombreRelancesCourrier}
              facturesCount={nombreFacturesCourrier}
              showOnlyTile={hasOnlyOneTile}
              text={courrierText}
              color="green"
              {...(pdfUrl && { onClick: handleCourrierClick })}
            />
          )}
        </div>

        {nombreMailsPotentiel > 0 && mailsSent < nombreMailsPotentiel && (
          <Header as="h5" color="orange" style={{ textAlign: 'center', margin: 0 }}>
            <Header.Content>
              {`${mailsSent} mail(s) envoyé(s) sur ${nombreMailsPotentiel}. Certains mails n'ont pas pu être envoyés.`}
            </Header.Content>
          </Header>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} size="tiny" basic icon="close" content="Fermer" />
      </Modal.Actions>
    </Modal>
  );
};

export default ModalRecapRelances;
